/* ---------------------------------------------------------------------
 *                           Import Packages
 * --------------------------------------------------------------------- */

// MUI
import { Box, Button, TextField, Typography } from "@mui/material";

/* ---------------------------------------------------------------------
 *                        RegisterForm Component
 * --------------------------------------------------------------------- */

/**
 * 定义注册表单组件
 * @param {object} param.formData - 表单数据
 * @param {function} param.onSubmit - 提交表单的回调函数
 * @param {function} param.onInputChange - 表单数据改变时的回调函数
 * @param {function} param.onSendCode - 发送验证码的回调函数
 * @param {number} param.countdown - 倒计时
 * @param  {function} param.handleModeChange - 切换登录模式时的回调函数
 * @param {function} param.handleSubmit - 提交表单的回调函数
 * @returns 注册表单组件
 * @function RegisterFrom
 */
export default function RegisterForm({
  formData,
  onSubmit,
  onInputChange,
  onSendCode,
  countdown,
  onModeChange,
}) {

  /**
   * 处理注册
   * @function handleRegister
   * @returns {Promise<void>}
   */
  const handleRegister = async() => {
    const userObj = {
      mobile: formData?.phone,
      password: formData?.password,
      smsCode: formData?.verificationCode,
    };
    await onSubmit("register", userObj);
  };

  /* ---------------------------------------------------------------------
   *                            Render Component
   * --------------------------------------------------------------------- */

  return (
    <>
      {/* 手机号 */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <Typography sx={{ minWidth: 110, fontSize: 20, fontWeight: 600 }}>
          手机号：
        </Typography>
        <TextField
          fullWidth
          placeholder="请输入手机号"
          name="phone"
          value={formData.phone}
          onChange={onInputChange}
          variant="outlined"
          size="small"
        />
      </Box>

      {/* 验证码 */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <Typography sx={{ minWidth: 110, fontSize: 20, fontWeight: 600 }}>
          验证码：
        </Typography>
        <TextField
          fullWidth
          placeholder="请输入验证码"
          name="verificationCode"
          value={formData.verificationCode}
          onChange={onInputChange}
          variant="outlined"
          size="small"
          sx={{ mr: 2 }}
        />
        <Button
          type="button"
          variant="contained"
          onClick={(e) => onSendCode(e)}
          disabled={countdown > 0 || !formData.phone}
          sx={{ minWidth: 100, textTransform: "none" }}
        >
          {countdown > 0 ? `${countdown}s` : "发送"}
        </Button>
      </Box>

      {/* 密码 */}
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Typography sx={{ minWidth: 110, fontSize: 20, fontWeight: 600 }}>
            设置密码：
          </Typography>
          <TextField
            fullWidth
            placeholder="请输入密码"
            name="password"
            type="password"
            value={formData.password}
            onChange={onInputChange}
            variant="outlined"
            size="small"
          />
        </Box>
        <Typography fontSize={14} color="#888" ml={14} mb={1}>
          密码要求：6-15个字符，英文或数字
        </Typography>
      </Box>

      {/* 注册按钮 */}
      <Box textAlign="center" mt={4}>
        <Button
          type="submit"
          variant="outlined"
          onClick={handleRegister}
          sx={{
            height: 54,
            px: 10,
            textTransform: "none",
            fontSize: 22,
            fontWeight: 700,
            borderRadius: 2,
          }}
        >
          注册
        </Button>
      </Box>

      {/* 已有账号？去登录 */}
      <Box textAlign="center" mt={3}>
        <Typography fontSize={14} color="text.secondary">
          已有账号？
          <Button
            variant="text"
            color="primary"
            sx={{ ml: 1, p: 0, fontSize: 14, textTransform: "none" }}
            onClick={() => onModeChange("login")}
          >
            去登录
          </Button>
        </Typography>
      </Box>
    </>
  );
}
